module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/cmentarz.jpg?8026ab8c";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/cmentarz.jpg
// module id = 2323
// module chunks = 0